import React from "react";

import StaticBulletList from "components/StaticBulletList";

export function CrmHeader() {
  return (
    <StaticBulletList
      header={
        <div style={{ textAlign: "center" }}>
          <div>Welcome to Hubly!</div>
          <div>Connect with your CRM to get started.</div>
        </div>
      }
      legend="Securely integrate with your CRM to automatically import your clients 
        and keep your data up-to-date. 
        Integrating your CRM grants Hubly access to the following information:"
      items={[
        "Personal account information",
        "All contact records and details",
        "All comments and tags",
      ]}
    />
  );
}

export default CrmHeader;
